<template>
  <div :class="[$style.base, {[$style.smallScreen]: $screen === 's'}]">
    <div :class="$style.left">test</div>
    <div :class="$style.right"></div>
  </div>
</template>

<script
  lang="ts"
  setup
>
</script>

<style
  lang="scss"
  module
>

.base {
  display: flex;

  &.smallScreen {
    flex-direction: column;
  }
}

.left {
  background-color: var(--color-primary);
}
</style>
